import React, { useState } from "react"
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"
import { Link } from "react-router-dom"
import { Spinner } from "reactstrap"
import { get } from "helpers/api_helper"
import moment from "moment"

export const ExportJsonToExcel = ({
  arrData = [],
  fileName = "excel",
  dateColumns = [],
}) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
  const timeStamp = `-${moment().unix()}-`
  const fileExtension = ".xlsx"

  const exportToCSV = (jsonData = [], fileName = "excel", dateCol = []) => {
    let jsonDataTZ = jsonData.map(row => {
      console.log("🚀 ~ exportToCSV ~ dateCol:", dateCol)
      const DATE_COL_DEF = [
        "createdAt",
        "createdDate",
        "updatedAt",
        "updatedDate",
      ]
      const DATE_COL = [...new Set([...DATE_COL_DEF, ...dateCol])]
      for (const keyDC of DATE_COL) {
        if (row[keyDC]) {
          row[keyDC] = moment(row.create_at).format("YYYY-MM-DD HH:mm:ss")
        }
      }
      return row
    })

    const ws = XLSX.utils.json_to_sheet(jsonDataTZ)
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] }
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(data, fileName + timeStamp + fileExtension)
    setExportLoading(false)
  }

  const [exportLoading, setExportLoading] = useState()
  const handleExport = () => {
    setExportLoading(true)
    exportToCSV(arrData, fileName, dateColumns)
  }

  return (
    <a className={`btn btn-success`} onClick={handleExport}>
      <i className="bx bx-export"></i> Export{" "}
      {exportLoading && (
        <Spinner
          size="sm"
          className="ms-2"
          color="light"
          setLoading={setExportLoading}
        />
      )}
    </a>
  )
}
